import { __assign, __rest } from "tslib";
import React from 'react';
import InternalColumnLayout, { COLUMN_TRIGGERS } from './internal';
import { getExternalProps } from '../internal/utils/external-props';
import { useContainerBreakpoints } from '../internal/hooks/container-queries';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import useBaseComponent from '../internal/hooks/use-base-component';
export default function ColumnLayout(_a) {
    var props = __rest(_a, []);
    var baseComponentProps = useBaseComponent('ColumnLayout');
    var _b = useContainerBreakpoints(COLUMN_TRIGGERS), breakpoint = _b[0], ref = _b[1];
    var externalProps = getExternalProps(props);
    return React.createElement(InternalColumnLayout, __assign({}, externalProps, baseComponentProps, { __breakpoint: breakpoint, ref: ref }));
}
applyDisplayName(ColumnLayout, 'ColumnLayout');
//# sourceMappingURL=index.js.map